module.exports = __webpack_public_path__ + "img/camiseta-cinza.8d1fc9a7.jpg";